import { createRoute, lazyRouteComponent, notFound, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { authenticatedRoute } from '@/app/routes/authenticated'
import { requirePermission } from '@/shared/auth/guards'

import { isLookupKind } from './api'

const lookupSearchSchema = z.object({
  page: z.number().int().positive().optional().catch(undefined),
  sort: z.string().optional().catch(undefined),
  search: z.string().optional().catch(undefined),
})

export const segmentationIndexRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/segmentation',
  beforeLoad: () => {
    throw redirect({ to: '/segmentation/$kind', params: { kind: 'positions' } })
  },
})

export const lookupsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/segmentation/$kind',
  validateSearch: (search) => lookupSearchSchema.parse(search),
  beforeLoad: requirePermission('users.view'),
  loader: ({ params }) => {
    if (!isLookupKind(params.kind)) throw notFound()

    return { kind: params.kind }
  },
  component: lazyRouteComponent(() => import('./pages/lookups-page'), 'LookupsPage'),
})

export const appModulesRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/app-modules',
  validateSearch: (search) => z.object({ page: lookupSearchSchema.shape.page }).parse(search),
  beforeLoad: requirePermission('users.view'),
  component: lazyRouteComponent(() => import('./pages/app-modules-page'), 'AppModulesPage'),
})

export const segmentationRoutes = [segmentationIndexRoute, lookupsRoute, appModulesRoute]
